export function buildPreschoolStudentsPayload(formValues, learningAreas) {
  const competenceIDs = new Set(
    (Array.isArray(learningAreas) ? learningAreas : []).flatMap((area) =>
      (Array.isArray(area?.competences) ? area.competences : [])
        .map((competence) => competence?.competenceID)
        .filter((competenceID) => competenceID != null)
        .map(String),
    ),
  );

  return Object.fromEntries(
    Object.entries(formValues || {})
      .map(([studentID, studentValues]) => [
        String(studentID),
        Object.fromEntries(
          Object.entries(studentValues || {}).filter(
            ([fieldID, gradeID]) =>
              competenceIDs.has(String(fieldID)) &&
              gradeID !== undefined &&
              gradeID !== null,
          ),
        ),
      ])
      .filter(([, scores]) => Object.keys(scores).length > 0),
  );
}
